var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "detail",
    attrs: {
      "id": "subnet_details"
    }
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": _vm.breadcrumbs
    }
  }), !_vm.subnetsLoaded ? [_c('Loader', {
    attrs: {
      "content-id": _vm.subnetID,
      "message": 'Fetching Subnet Details'
    }
  })] : [_c('div', {
    staticClass: "card"
  }, [_c('Content', {
    attrs: {
      "subnet-i-d": _vm.subnetID,
      "subnet": _vm.subnets[_vm.subnetID]
    }
  })], 1)]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }